import usePriceRangeItem from "features/configuration/GeneralConfiguration/ConfigurationItem/usePriceRangeItem";
import Text from "common/Typography/Text";
import Flex from "common/Boxes/Flex";
import Link from "common/Typography/Link";
import { typography } from "@shared/common/Themes/typography";
import React, { useContext } from "react";
import { TradingTerminalContext } from "@shared/features/tradingTerminal/TradingTerminal.context";
import { FormFieldTitle } from "features/tradingTerminal/common/styles";
import PriceRangeInput from "common/Inputs/PriceRangeInput";
import { PriceRangeFormItemProps } from "@shared/features/tradingTerminal/common/types";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation";
import { LanguageNameSpaces } from "@shared/types";

const PriceRangeFormItem = ({ item, orderType }: PriceRangeFormItemProps) => {
  const {
    setShouldRedistributePriceTargets,
    showRedistributeTargetsButton,
    setShowRedistributeTargetsButton,
  } = useContext(TradingTerminalContext)!;
  const {
    itemValue,
    itemName,
    handleItemChange,
    validationMessage,
    error,
    precisionConfig,
  } = usePriceRangeItem(item);
  const { t } = useTypedTranslation(LanguageNameSpaces.TRADING_TERMINAL);

  const priceRangeExtraButton = orderType &&
    showRedistributeTargetsButton[orderType] && (
      <Link
        $size={typography.fontSizes.S}
        onClick={() => {
          if (orderType) {
            setShouldRedistributePriceTargets(orderType, true);
            setShowRedistributeTargetsButton(orderType, false);
          }
        }}
      >
        {t("buttons.redistribute_targets")}
      </Link>
    );

  return (
    <>
      <Flex $alignItems="baseline">
        <FormFieldTitle>{itemName}</FormFieldTitle>
        {priceRangeExtraButton}
      </Flex>
      <PriceRangeInput
        minMax={itemValue}
        precisionConfig={precisionConfig}
        onValueChange={handleItemChange}
        isForm={true}
      />
      <Text
        $size={typography.fontSizes.S}
        type={error ? "danger" : "secondary"}
        style={{ marginTop: 6 }}
      >
        {validationMessage}
      </Text>
    </>
  );
};

export default PriceRangeFormItem;
